import ForgotPassword from 'Pages/Auth/ForgotPassword';
import Login from 'Pages/Auth/Login';
import ResetPassword from 'Pages/Auth/ResetPassword';
import Activate from 'Pages/Auth/Activate';
import GuestCheckin from 'Pages/GuestCheckin';

export default [
  {path: '/login', component: Login, scopes: false},
  {path: '/forgot-password', component: ForgotPassword, scopes: false},
  {path: '/reset-password/:token', component: ResetPassword, scopes: false},
  {path: '/activate/:token', component: Activate, scopes: false},

  {path: '/guest-checkin', component: GuestCheckin, scopes: false}
];

